import React from "react";
import { ArrowButton } from "../../components/arrow-button";
import { PhotoColumn } from "../../components/photo-column";
import AvustralyaSema from '../../assets/photos/avustralya-zaviye/avustralya-postnisin-abdulaziz.jpg';
import AvustralyaSema1 from '../../assets/photos/avustralya-zaviye/avustralya-sema-1.jpg';
import AvustralyaSema2 from '../../assets/photos/avustralya-zaviye/avustraya-sema-2.jpg';
import AvustralyaSema3 from '../../assets/photos/avustralya-zaviye/avustraya-sema-3.jpg';
import AvustralyaSema4 from '../../assets/photos/avustralya-zaviye/avustraya-sema-4.jpg';
import AvustralyaSema5 from '../../assets/photos/avustralya-zaviye/avustraya-sema-5.jpg';
import AvustralyaSema6 from '../../assets/photos/avustralya-zaviye/avustraya-sema-6.jpg';
import "./sema.scss";
interface AvustralyaZaviyeProps {
    isVisible: boolean;
    comeBackSemaSection: Function;
}
interface AvustralyaZaviyeState {
    Change: boolean;
}



class AvustralyaZaviye extends React.Component<AvustralyaZaviyeProps, AvustralyaZaviyeState> {
    constructor(props: any) {
        super(props);
        this.state = {
            Change: true
        };
    }

    render() {
        return (
            <div style={{ display: this.props.isVisible ? "block" : "none" }}>
                <article>
                    <ArrowButton onClick={this.props.comeBackSemaSection} />
                    <h3 className="title">AVUSTRALYA MELBOURNE ŞEHRİNDEKİ ZAVİYE</h3>
                    <PhotoColumn
                        imageSource={AvustralyaSema}
                        imageTitle=""
                        figcaptionFirstTitle=""
                    />
                    <PhotoColumn
                        imageSource={AvustralyaSema1}
                        imageTitle=""
                        figcaptionFirstTitle=""
                    />
                    <PhotoColumn
                        imageSource={AvustralyaSema2}
                        imageTitle=""
                        figcaptionFirstTitle=""
                    />

                    <PhotoColumn
                        imageSource={AvustralyaSema3}
                        imageTitle=""
                        figcaptionFirstTitle=""
                    />

                    <PhotoColumn
                        imageSource={AvustralyaSema4}
                        imageTitle=""
                        figcaptionFirstTitle=""
                    />

                    <PhotoColumn
                        imageSource={AvustralyaSema5}
                        imageTitle=""
                        figcaptionFirstTitle=""
                    />

                    <PhotoColumn
                        imageSource={AvustralyaSema6}
                        imageTitle=""
                        figcaptionFirstTitle=""
                    />

                </article>
            </div>
        );
    }
}

export default AvustralyaZaviye;